import { ComponentType } from 'react';

import { TenantCreateModal } from '~components/shared/modals/tenant-create-modal/tenant-create-modal';
import { TenantInviteModal } from '~components/shared/modals/tenant-invite-modal/tenant-invite-modal';

import { useSpecificModal } from '~hooks/use-specific-modal';

type ModalProps = {
  open: boolean;
};

const MODALS_MAP: Record<string, ComponentType<ModalProps>> = {
  TENANT_INVITE_MODAL: TenantInviteModal,
  TENANT_CREATE_MODAL: TenantCreateModal,
};

export const ModalManager = () => {
  const { activeSpecificModal } = useSpecificModal();

  if (!activeSpecificModal) {
    return null;
  }

  const ModalComponent = MODALS_MAP[activeSpecificModal.modalId];

  if (!ModalComponent) {
    return null;
  }

  return <ModalComponent open />;
};
